// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoMessageInPlayer_wrapper__BFG8p","icon":"InfoMessageInPlayer_icon__WEFoY"};